<template>
  <div class="containerBox">
    <a
      v-if="!success && mode === 'client'"
      class="alipay"
      @click="closeModal"
      ><span class="border"></span>选择支付宝支付</a
    >
    <a
      v-if="!success && mode !== 'client'"
      style="padding-left: 40px"
      class="alipay"
      @click="closeModal"
      ><span class="border"></span>选择支付宝支付</a
    >
    <div class="whiteBG">
      <div class="container" v-if="orderInfo">
        <div class="title">
          支付金额：
          <span class="price">{{ orderInfo.orderPrice }}</span>
          元
        </div>
        <div class="des">
          订单编号：
          {{ orderInfo.orderNo }}
          | 订单信息：
          {{ orderInfo.orderDesc }}
        </div>
        <div class="content" v-if="!success">
          <img class="scanCode" v-if="wechatImg" :src="wechatImg" />
          <div v-else class="loading">
            <i class="el-icon-loading"></i>
          </div>
          <div class="line"></div>
          <img class="imgPhone" :src="require('img/payPhone.png')" alt="" />
        </div>
        <div v-if="success" class="successBox">
          <i class="el-icon-circle-check"></i>
          支付成功
        </div>
        <div class="successDes" v-if="success">
          正在打印中，请到对应的打印机前领取文件
        </div>
      </div>
      <div v-if="isError">
        <div class="errorBox">
          <i class="el-icon-circle-close"></i>
          查询订单信息失败
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { orderInfo, crateVipOrder, createOrder } from "api/api";
import store from "../../../store";
import { generateSign } from "../../../utils/foxitSign.js";
import QRCode from "qrcode";

export default {
  data() {
    return {
      orderInfo: null,
      alipayUrl: null,
      wechatImg: null,
      success: false,
      isError: false,
    };
  },
  props: {
    orderId: {
      type: String || null,
      default: null,
    },
    mode: {
      type: String,
      default: "client",
    },
    destoryDlg: {
      type: Function,
    }
  },
  mounted() {
    if (!this.orderId) return (this.isError = true);
    if (this.mode === "web") {
      this.token =
        (localStorage.getItem("token") &&
          JSON.parse(localStorage.getItem("token")) &&
          JSON.parse(localStorage.getItem("token")).token) ||
        "";
      this.accessToken = store.state.user.accessToken;
    } else {
      this.token = this.$route.query.token;
      this.accessToken = window.cloudCookies.accessToken;
    }
    if (!this.token && !this.accessToken) return (this.isError = true);
    this.headers = this.token
      ? { token: this.token }
      : {
          Authorization: `Bearer ${this.accessToken}`,
        };
    orderInfo(
      {
        orderId: this.orderId,
      },
      {
        noErrorHandler: true,
        noAuth: true,
        noToken: true,
        headers: this.headers,
      }
    ).then(({ data = null, code, timeStamp }) => {
      if (code !== 0 || !data) return (this.isError = true);
      this.orderInfo = { ...data, timeStamp };
      if (data.orderPayStatus === 2) return (this.success = true);
      // 创建VIP支付
      this.createVipOrder({ ...data, timeStamp }, "wechat")
        .then((wechatRes) => {
          QRCode.toDataURL(wechatRes.codeUrl)
            .then((url) => {
              this.wechatImg = url;
              setTimeout(() => {
                if (this._isDestroyed) return;
                this.getOrderStatus();
              }, 3000);
            })
            .catch(() => {
              this.$message.error("获取支付二维码失败");
            });
        })
        .catch(() => {
          this.$message.error("创建支付订单失败");
        });
    });
  },
  computed: {
    ...mapState("batch", ["order"]),
  },
  methods: {
    createVipOrder(orderInfo, payType) {
      const { vipOrderId, timeStamp } = orderInfo;
      const requestData = {
        appId: "Zjy5QwG6",
        orderFrom: 0,
        returnUrl: `https://dy.foxitcloud.cn/success?name=${encodeURIComponent(
          orderInfo.equipmentAlias
        )}`,
        version: "1.0",
        reqTime: timeStamp.replace(/[^0-9]/g, ""),
        orderId: vipOrderId,
        wayCode: payType === "wechat" ? "WX_NATIVE" : "ALI_PC",
      };
      const { sign, nonce } = generateSign(requestData);
      requestData.sign = sign;
      const config = {
        headers: {
          "foxit-sign": sign,
          "foxit-nonce": nonce,
          "foxit-timeStamp": new Date(timeStamp).getTime(),
          "Content-Type": "application/json;charset=utf-8",
          ...this.headers,
        },
        noErrorHandler: true,
        noAuth: true,
        noToken: true,
      };
      return new Promise((resolve, reject) => {
        crateVipOrder(requestData, config, this.orderInfo.payeeUserId)
          .then(({ code, data }) => {
            if (code === 0) {
              resolve(data);
            } else {
              reject();
            }
          })
          .catch(() => {
            reject();
          });
      });
    },
    closeModal() {
      if (this.alipayUrl) {
        if (this.mode === "client") {
          window.location.href = this.alipayUrl;
        } else {
          window.open(this.alipayUrl);
        }
        this.$emit("closeBillModal");
        this.$emit("toggleConfirmModal", true);
        return;
      }
      if (this.hadClickAliPay) return;
      this.hadClickAliPay = true;
      if (this.timeStamp) this.orderInfo.timeStamp = this.timeStamp;
      this.createVipOrder(this.orderInfo, "ali").then((aliRes) => {
        this.hadClickAliPay = false;
        this.alipayUrl = aliRes.payUrl;
        if (this.mode === "client") {
          window.location.href = this.alipayUrl;
        } else {
          window.open(this.alipayUrl);
        }
        this.$emit("closeBillModal");
        this.$emit("toggleConfirmModal", true);
      }).catch(() => {
        this.$message.error("创建支付宝订单失败");
        this.hadClickAliPay = false;
      });
    },
    getOrderStatus() {
      orderInfo(
        { orderId: this.orderId },
        {
          noErrorHandler: true,
          noAuth: true,
          noToken: true,
          headers: this.headers,
        }
      ).then(({ data, code, timeStamp }) => {
        this.timeStamp = timeStamp;
        if (code !== 0) return;
        if (data.orderPayStatus === 2) {
          if (this.destoryDlg && typeof(this.destoryDlg) === "function") this.destoryDlg();
          if (this.mode === "web") {
            this.$emit("closeBillModal");
            this.$emit("toggleConfirmModal", true);
          } else {
            this.success = true;
          }
        }
        if (data.orderPayStatus === 1 && !this._isDestroyed) {
          setTimeout(() => {
            this.getOrderStatus();
          }, 3000);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.containerBox {
  margin: 26px auto 0;
}

.whiteBG {
  width: 1000px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 600px;
}

.container {
  margin-top: -15px;
  padding-bottom: 90px;
  width: 512px;
  height: 393px;
  background-color: white;
}

.title {
  text-align: center;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #424242;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  .price {
    font-size: 24px;
    color: #ff3333;
    font-weight: bold;
  }
}
.des {
  text-align: center;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #999999;
  margin-top: 15px;
  margin-bottom: 80px;
}

.content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .scanCode {
    width: 189px;
    height: 189px;
    background-color: rgba($color: #999999, $alpha: 0.05);
  }
  .loading {
    width: 189px;
    height: 189px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba($color: #999999, $alpha: 0.05);
    i {
      font-size: 28px;
    }
  }
  .line {
    width: 1px;
    height: 148px;
    background: #eaeaea;
  }
  .imgPhone {
    width: 161px;
    height: 223px;
  }
}

.alipay {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #666666;
  display: flex;
  margin-bottom: 20px;
  align-items: center;
  cursor: pointer;
  .border {
    border-left: 1px solid #666666;
    border-bottom: 1px solid #666666;
    display: block;
    width: 10px;
    height: 10px;
    transform: rotate(45deg);
  }
}

.alipayBottom {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #666666;
  display: flex;
  margin-bottom: 20px;
  align-items: center;
  .border {
    border-left: 1px solid #666666;
    border-bottom: 1px solid #666666;
    display: block;
    width: 10px;
    height: 10px;
    transform: rotate(45deg);
  }
}

.successBox {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  i {
    margin-right: 20px;
    font-size: 80px;
    color: #67c23a;
  }
}

.errorBox {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  i {
    margin-right: 20px;
    font-size: 80px;
    color: #f56c6c;
  }
}

.successDes {
  margin-top: 20px;
  font-size: 18px;
  text-align: center;
}
</style>
